import { BasePlot } from './base_plot'

export interface IDataSource {
  public function connect(app:App);
  public function isConnected(): boolean;
}

export class AudioSource implements IDataSource {
  private context: AudioContext;
  public fftSize: number;
  private analyzer;
  private scriptProcessor;
  private source;
  public useMic: boolean;

  constructor(fftSize: number){
    this.fftSize = fftSize;
  }

  public function initWebAudio(){
    window.AudioContext = window.AudioContext || window.webkitAudioContext;
    this.context = new AudioContext();
  }

  public function connect(app:App)
  {
      this.initWebAudio();
      var audio_source_file = 'loop.wav';
      this.source = this.context.createBufferSource();
      this.source.loop = true;
      this.source.connect(this.context.destination);


      this.analyser = this.context.createAnalyser();
      this.analyser.smoothingTimeConstant = 0;
      this.analyser.fftSize = this.fftSize;
      this.source.connect(this.analyser);


      this.scriptProcessor = this.context.createScriptProcessor(256, 1, 1);
      this.scriptProcessor.connect(this.context.destination);

      this.scriptProcessor.onaudioprocess = () => {
           var array = new Uint8Array(this.analyser.frequencyBinCount);
           this.analyser.getByteFrequencyData(array);
           app.callback({"spec": array});
       };

      this.analyser.connect(this.scriptProcessor);

      if (this.useMic) {
        navigator.mediaDevices.getUserMedia({ audio: true, video: false })
          .then((stream) => {
            this.source = this.context.createMediaStreamSource(stream);

            this.source.connect(this.analyser);
          });
      } else{
        var request = new XMLHttpRequest();
        request.open('get', audio_source_file, true);
        request.responseType = 'arraybuffer';
        request.onload = (() => {
            this.context.decodeAudioData(request.response, ((buffer) => {
                this.source.buffer = buffer;
                this.source.start(0);
            });
        };
        request.send();
      }
  }

  public function disconnect(): void {
    if (this.source != null){
      this.source.disconnect();
    }
  }
  public function isConnected(): boolean
  {
    return true;
  }
}


export class DataSource implements IDataSource {
  private ws: WebSocket;

  public function connect(app:App)
  {
    this.ws = new WebSocket("ws://127.0.0.1:9000/");
    console.log(this.ws);
    this.ws.onmessage = (m) => app.callback(JSON.parse(m.data));
  }
  public function isConnected(): boolean
  {
    console.log(this.ws.readyState);
    return this.ws.readyState != 3; // 1 = OPEN
  }
  public function disconnect(): void
  {

  }
}

export class App {
  private targets: Array<BasePlot>;
  public function run(source: DataSource, targets: Array<BasePlot>): void
  {
    this.targets = targets;
    if (source) {
      source.disconnect();
      source.connect(this);
      setInterval(() => {
        if (!source.isConnected()){
          source.connect(this);
        }
      }, 5000);
    }
    this.redraw();
  }

  public function callback(data){
    this.targets.forEach(function (target: BasePlot){
      if (target.key in data)
      {
        target.update(data[target.key]);
      }
    })
  }

  private function draw() {
    this.targets.forEach(function (target: BasePlot){
      target.render();
    });
  }

  private function redraw(){
    requestAnimationFrame(() => {
      this.draw();
      this.redraw();
    });
  }
}
